/* angular */
import { createAction, props } from '@ngrx/store';
import {
  GetTokenByCredentialsActionPayload,
  GetTokenByCredentialsSuccessfulActionPayload,
  LoggedInActionPayload,
  RegisterActionPayload,
  RegisterSuccessfulActionPayload,
  SetUserActionPayload,
  LoginByTokenActionPayload,
  SetTokenActionPayload,
  LoginByDescopeTokenWithoutDeviceActionPayload,
  LoginByDescopeTokenWithoutDeviceSuccessfulActionPayload,
  GenerateLoginRequestSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/auth-data-store';

/* action types */
export enum ActionTypes {
  GetTokenByCredentials = '[AUTHDATASTORE] GetTokenByCredentials',
  GetTokenByCredentialsSuccessful = '[AUTHDATASTORE] GetTokenByCredentialsSuccessful',
  GetTokenByCredentialsFailure = '[AUTHDATASTORE] GetTokenByCredentialsFailure',
  Logout = '[AUTHDATASTORE] Logout',
  LoginByToken = '[AUTHDATASTORE] LoginByToken',
  LoginByDescopeTokenWithoutDevice = '[AUTHDATASTORE] LoginByDescopeTokenWithoutDevice',
  LoginByDescopeTokenWithoutDeviceSuccessful = '[AUTHDATASTORE] LoginByDescopeTokenWithoutDeviceSuccessful',
  GenerateLoginRequest = '[AUTHDATASTORE] GenerateLoginRequest',
  GenerateLoginRequestCreated = '[AUTHDATASTORE] GenerateLoginRequestCreated',
  GenerateLoginRequestSuccessful = '[AUTHDATASTORE] GenerateLoginRequestSuccessful',
  LoggedIn = '[AUTHDATASTORE] LoggedIn',
  LoginByTokenFailure = '[AUTHDATASTORE] LoginByTokenFailure',
  Register = '[AUTHDATASTORE] Register',
  RegisterSuccessful = '[AUTHDATASTORE] RegisterSuccessful',
  RegisterFailure = '[AUTHDATASTORE] RegisterFailure',
  SetUser = '[AUTHDATASTORE] SetUser',
  SetToken = '[AUTHDATASTORE] SetToken',
  ClearToken = '[AUTHDATASTORE] ClearToken',
  NavigateToLoginPage = '[AUTHDATASTORE] NavigateToLoginPage',
  NavigateToRegisterPage = '[AUTHDATASTORE] NavigateToRegisterPage',
}

/* actions */

export const GetTokenByCredentials = createAction(
  ActionTypes.GetTokenByCredentials,
  props<{ payload: GetTokenByCredentialsActionPayload }>(),
);

export const GetTokenByCredentialsSuccessful = createAction(
  ActionTypes.GetTokenByCredentialsSuccessful,
  props<{ payload: GetTokenByCredentialsSuccessfulActionPayload }>(),
);

export const GetTokenByCredentialsFailure = createAction(
  ActionTypes.GetTokenByCredentialsFailure,
);

export const Logout = createAction(ActionTypes.Logout);

export const LoginByToken = createAction(
  ActionTypes.LoginByToken,
  props<{ payload: LoginByTokenActionPayload }>(),
);

export const LoginByDescopeTokenWithoutDevice = createAction(
  ActionTypes.LoginByDescopeTokenWithoutDevice,
  props<{ payload: LoginByDescopeTokenWithoutDeviceActionPayload }>(),
);

export const LoginByDescopeTokenWithoutDeviceSuccessful = createAction(
  ActionTypes.LoginByDescopeTokenWithoutDeviceSuccessful,
  props<{ payload: LoginByDescopeTokenWithoutDeviceSuccessfulActionPayload }>(),
);

export const GenerateLoginRequest = createAction(
  ActionTypes.GenerateLoginRequest,
);

export const GenerateLoginRequestCreated = createAction(
  ActionTypes.GenerateLoginRequestCreated,
  props<{ payload: GenerateLoginRequestSuccessfulActionPayload }>(),
);

export const GenerateLoginRequestSuccessful = createAction(
  ActionTypes.GenerateLoginRequestSuccessful,
  props<{ payload: GenerateLoginRequestSuccessfulActionPayload }>(),
);

export const LoggedIn = createAction(
  ActionTypes.LoggedIn,
  props<{ payload: LoggedInActionPayload }>(),
);

export const LoginByTokenFailure = createAction(
  ActionTypes.LoginByTokenFailure,
);

export const Register = createAction(
  ActionTypes.Register,
  props<{ payload: RegisterActionPayload }>(),
);

export const RegisterSuccessful = createAction(
  ActionTypes.RegisterSuccessful,
  props<{ payload: RegisterSuccessfulActionPayload }>(),
);

export const RegisterFailure = createAction(ActionTypes.RegisterFailure);

export const SetUser = createAction(
  ActionTypes.SetUser,
  props<{ payload: SetUserActionPayload }>(),
);

export const SetToken = createAction(
  ActionTypes.SetToken,
  props<{ payload: SetTokenActionPayload }>(),
);

export const ClearToken = createAction(ActionTypes.ClearToken);

export const NavigateToLoginPage = createAction(
  ActionTypes.NavigateToLoginPage,
);

export const NavigateToRegisterPage = createAction(
  ActionTypes.NavigateToRegisterPage,
);
